import type { ReactNode } from 'react';
import { Logo } from '@/components/Logo';

interface AuthLayoutProps {
  title: string;
  subtitle: string;
  children: ReactNode;
}

/** Carte centrée des pages hors connexion (login, mot de passe oublié…) */
export function AuthLayout({ title, subtitle, children }: AuthLayoutProps) {
  return (
    <div className="min-h-screen bg-slate-50 flex flex-col items-center justify-center p-4">
      <div className="w-full max-w-md bg-card rounded-2xl shadow-xl border border-slate-200 overflow-hidden">
        <div className="p-8 pb-6 flex flex-col items-center text-center">
          <Logo size={32} className="p-3 rounded-xl mb-4 shadow-lg shadow-blue-600/20" />
          <h1 className="text-2xl font-bold text-slate-900">{title}</h1>
          <p className="text-slate-500 mt-2">{subtitle}</p>
        </div>

        <div className="border-t border-slate-100 bg-slate-50 p-8 pt-6">{children}</div>
      </div>

      <p className="mt-8 text-xs text-slate-400 text-center max-w-xs">© {new Date().getFullYear()} Webcentric</p>
    </div>
  );
}
